import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppSettingProvider } from "./context/appSettingContext";
import { FreezeProvider } from "./context/useFreeze";
import "./custom-style.css";
// import register from "./serviceWorkerRegistration"; // Correct default import
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter basename="/">
        <AppSettingProvider>
            <FreezeProvider>
                <App />
            </FreezeProvider>
        </AppSettingProvider>
    </BrowserRouter>
);

let deferredPrompt;

window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    console.log(`'beforeinstallprompt' event was fired.`);
});

function triggerInstallPrompt() {
    if (deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === "accepted") {
                console.log("User accepted the A2HS prompt");
            } else {
                console.log("User dismissed the A2HS prompt");
            }
            deferredPrompt = null;
        });
    } else {
        console.warn("No deferredPrompt available at the moment.");
    }
}

window.addEventListener("trueValuePWA", triggerInstallPrompt);
